export default __webpack_public_path__ + "static/abby_h-f9d4cc1c2478d232c253c92bdb88188f.png";